import { createFileRoute } from "@tanstack/react-router";

import { CookiePolicyPage } from "@/components/marketing/cookie-policy-page";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/cookie-policy")({
  head: () => pageHead("cookiePolicy"),
  component: CookiePolicyPage,
});
